import { useState } from 'react';

interface LlmLogsViewerProps {
  input: string;
  output: string;
}

export function LlmLogsViewer({ input, output }: LlmLogsViewerProps) {
  const [showInput, setShowInput] = useState(false);
  const [showOutput, setShowOutput] = useState(true);

  // Handle undefined/null values
  const safeInput = input || '';
  const safeOutput = output || '';

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
  };

  const formatJson = (text: string) => {
    try {
      return JSON.stringify(JSON.parse(text), null, 2);
    } catch {
      return text;
    }
  };

  return (
    <div className="space-y-4">
      {/* Input Section */}
      <div className="border rounded">
        <div
          className="px-4 py-3 bg-gray-50 border-b flex items-center justify-between cursor-pointer hover:bg-gray-100"
          onClick={() => setShowInput(!showInput)}
        >
          <div className="flex items-center gap-2">
            <span className="font-semibold text-sm">📥 Input (Prompt envoyé au LLM)</span>
            <span className="text-xs text-gray-500">
              {safeInput.length} caractères
            </span>
          </div>

          <div className="flex items-center gap-2">
            <button
              onClick={(e) => {
                e.stopPropagation();
                copyToClipboard(safeInput);
              }}
              className="text-xs text-blue-600 hover:text-blue-800"
            >
              📋 Copier
            </button>
            <span className="text-gray-400">{showInput ? '▼' : '▶'}</span>
          </div>
        </div>

        {showInput && (
          <div className="p-4 bg-white">
            <pre className="whitespace-pre-wrap font-mono text-xs text-gray-800 max-h-96 overflow-y-auto">
              {safeInput}
            </pre>
          </div>
        )}
      </div>

      {/* Output Section */}
      <div className="border rounded">
        <div
          className="px-4 py-3 bg-gray-50 border-b flex items-center justify-between cursor-pointer hover:bg-gray-100"
          onClick={() => setShowOutput(!showOutput)}
        >
          <div className="flex items-center gap-2">
            <span className="font-semibold text-sm">📤 Output (Réponse du LLM)</span>
            <span className="text-xs text-gray-500">
              {safeOutput.length} caractères
            </span>
          </div>

          <div className="flex items-center gap-2">
            <button
              onClick={(e) => {
                e.stopPropagation();
                copyToClipboard(formatJson(safeOutput));
              }}
              className="text-xs text-blue-600 hover:text-blue-800"
            >
              📋 Copier
            </button>
            <span className="text-gray-400">{showOutput ? '▼' : '▶'}</span>
          </div>
        </div>

        {showOutput && (
          <div className="p-4 bg-white">
            <pre className="whitespace-pre-wrap font-mono text-xs text-gray-800 max-h-96 overflow-y-auto">
              {formatJson(safeOutput)}
            </pre>
          </div>
        )}
      </div>
    </div>
  );
}
